module.exports = __webpack_public_path__ + "static/media/07-Belgravia.af37b444.mp4";